import { render, staticRenderFns } from "./Filtros.vue?vue&type=template&id=470b733a&scoped=true&"
import script from "./Filtros.vue?vue&type=script&lang=js&"
export * from "./Filtros.vue?vue&type=script&lang=js&"
import style0 from "./NavBar/style.css?vue&type=style&index=0&id=470b733a&scoped=true&lang=css&"
import style1 from "./Filtros.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b733a",
  null
  
)

export default component.exports